import { render, staticRenderFns } from "./TexasHistoryButton.vue?vue&type=template&id=0096830e&scoped=true&"
import script from "./TexasHistoryButton.vue?vue&type=script&lang=js&"
export * from "./TexasHistoryButton.vue?vue&type=script&lang=js&"
import style0 from "./TexasHistoryButton.vue?vue&type=style&index=0&id=0096830e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0096830e",
  null
  
)

component.options.__file = "TexasHistoryButton.vue"
export default component.exports